import SideMenu from '@/containers/side-menu/SideMenu.vue'
import EmployeeMap from '@/pages/employee-map/EmployeeMap.vue'

export default {
  path: '/employee-map',
  name: 'EmployeeMap',
  components: {
    mainContent: EmployeeMap,
    mainMenu: SideMenu
  },
  meta: {
    role: {
      sectorId: 'employee-map'
    },
    breadcrumb: {
      title: 'Mapa dos Monitores',
      paths: [
        { title: 'mapas' },
        { title: 'monitores' },
      ]
    }
  }
}